"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Heart = function Heart(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.986 12.811a26.654 26.654 0 0 1 37.704 0 26.653 26.653 0 0 1 0 37.703L49.412 88.79a2 2 0 0 1-2.828 0L8.308 50.514c-10.41-10.412-10.41-27.292 0-37.703C18.72 2.399 35.6 2.399 46.011 12.81l1.28 1.28a1 1 0 0 0 1.415 0l1.28-1.28zm-.573 66.08l28.864-28.865 4.463-4.463a19.654 19.654 0 0 0 0-27.802 19.655 19.655 0 0 0-27.804 0l-5.523 5.523a2 2 0 0 1-2.828 0l-5.523-5.524c-7.678-7.677-20.126-7.677-27.804 0-7.677 7.678-7.677 20.126 0 27.804L46.585 78.89a2 2 0 0 0 2.828 0z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Heart;